import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payments-new-gateway',
  templateUrl: './payments-new-gateway.component.html',
  styleUrls: ['./payments-new-gateway.component.scss']
})
export class PaymentsNewGatewayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
